import { render, staticRenderFns } from "./DesignBorder.vue?vue&type=template&id=3b315faa&"
import script from "./DesignBorder.vue?vue&type=script&lang=js&"
export * from "./DesignBorder.vue?vue&type=script&lang=js&"
import style0 from "./DesignBorder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports